import logo from '../../imagenes/logo.svg';

import './Header.scss';

const Header = () => {

	return (
      <header className="header">
        <div className="logo-section">
          <img src={logo} alt="Logo" className="logo" />
          <span className="company-name">Pedagogía Interactiva</span>
        </div>
        <div className="school-text">New English and Me 2</div>
      </header>
	)
}

export default Header;